export const FallbackCorvidModel = {
    componentType: 'Fallback',
    loadSDK: () => import('./Fallback.corvid' /* webpackChunkName: "Fallback.corvid" */),
};
export default FallbackCorvidModel;
//# sourceMappingURL=entry.corvid.js.map